import { Button } from '@heidi/design-system/button';
import { TypographyP } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';

interface RateLimitErrorBlockProps {
  onRetry?: () => void;
}

export const RateLimitErrorBlock = ({
  onRetry,
}: RateLimitErrorBlockProps): JSX.Element => {
  const { t } = useTranslations();

  return (
    <div className="flex w-full flex-row items-center gap-3 rounded-lg border border-validation-destructive-border bg-validation-destructive-muted p-4">
      <TypographyP className="min-w-0 flex-1 text-sm text-validation-destructive">
        {t('chat.rateLimitError.message' as never)}
      </TypographyP>
      {onRetry && (
        <Button
          variant="outline"
          size="md"
          onClick={() => void onRetry()}
          className="shrink-0 transition-colors"
        >
          {t('chat.rateLimitError.tryAgain' as never)}
        </Button>
      )}
    </div>
  );
};
